import privacyList from '../../data/haPrivacyList.json'
import { Container } from 'react-bootstrap'

const HaPrivacy = () => {
  return (
    <>
      {' '}
      <Container
        style={{
          padding: '1rem',
          textAlign: 'justify',
          fontFamily: 'Noto Sans TC,sans-serif',
        }}
      >
        <div style={{ padding: '1rem', lineHeight: '1.5' }}>
          <h4 style={{ color: '#28d9c4' }}>隱私權保護聲明</h4>
          <p>最後更新⽇期：2022年11⽉ 25⽇</p>
          <p>
            浚鴻數據開發股份有限公司（下稱「本公司」），尊重並承諾保護使用者隱私，在您使⽤本公司所提供的HA！健康服務（以下稱「本應用程式」）前，特向您說明本應用程式之隱私權政策（下稱「本聲明」），請您詳閱下列內容，以保障您的權益：
          </p>
        </div>
        {privacyList.map((item, index) => {
          return (
            <div key={index} style={{ padding: '1rem' }}>
              <h4>{item.title}</h4>
              <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>
                {item.content}
              </p>
              {/* {item.url && (
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.url}
                </a>
              )} */}
            </div>
          )
        })}
      </Container>
    </>
  )
}

export default HaPrivacy
